import { MutableRefObject, useEffect, useReducer } from 'react';
// 方法
import { getInitOptions, setOptionsFormItems } from '../util';
// 常量
import { FormInstance } from 'antd';
import { SuperFormItemProps } from '../../SuperForm/interface';
import { IOptionalFormItems, IStrategyPageAction, IStrategyPageContext, IStrategyPagePayload, StrategyPageType } from '../interface';
import { DEFAULT_FIELD_NAMES } from '../../SuperSelect/interface';

const initStrategyPageData: IStrategyPageContext = {
  visible: false,
  pageType: 'add',
  ruleFormItems: [],
  actionFormItems: [],
  optionalFormItems: [],
  contentFormItems: [],
};

// Action
function strategyPageAction(
  state: IStrategyPageContext,
  action: IStrategyPageAction,
) {
  switch (action.type) {
    case 'init':
      return {
        ...state,
        optionalFormRef: action.payload.optionalFormRef,
        ruleFormItems: action.payload.ruleFormItems ?? [],
        optionalFormItems: action.payload.optionalFormItems ?? [],
        actionFormItems: action.payload.actionFormItems ?? [],
      };
    case 'change':
      return {
        ...state,
        ...action.payload,
      };
    case 'initContentFormItems':
      const { optionalValues, initValues, } = action.payload;
      if (optionalValues || initValues?.action || initValues?.rule) {
        /** 左侧基础信息表单配置 */
        let newRuleFormItems: SuperFormItemProps[] = state.ruleFormItems;
        /** 中间内容区域表单配置 */
        let newContentFormItems: SuperFormItemProps[] = [];
        /** 右侧执行动作表单配置 */
        let newActionFormItems: SuperFormItemProps[] = state.actionFormItems;
        if (optionalValues) {
          const optionalFormItems = state.optionalFormItems;
          for (let [key, values] of Object.entries(optionalValues)) {
            const findGroup = optionalFormItems.find(item => item.value === key);
            if (findGroup && Array.isArray(values)) {
              const childrenFormItems: SuperFormItemProps[] = [];
              findGroup.children.forEach(item => {
                const { disabled, ...restItem } = item;
                if ((values as string[]).includes(item.name as string)) {
                  switch (item.formItemType) {
                    case 'SelectTab':
                      const { labelKey: tabLabelKey, valueKey: tabValueKey, selectTabProps, } = item;
                      if (selectTabProps) {
                        const newInitOptions = getInitOptions({
                          initValues: initValues?.content,
                          labelKey: tabLabelKey,
                          valueKey: tabValueKey,
                          initOptions: selectTabProps?.initOptions,
                          labelField: selectTabProps?.fieldNames?.label || DEFAULT_FIELD_NAMES.label,
                          valueField: selectTabProps.fieldNames?.value || DEFAULT_FIELD_NAMES.value,
                        });
                        childrenFormItems.push({
                          ...restItem,
                          required: true,
                          selectTabProps: {
                            ...selectTabProps,
                            initOptions: newInitOptions,
                          },
                        });
                      }
                      break;
                    case 'SuperSelectTable':
                      const { labelKey, valueKey, superSelectTableProps, } = item;
                      if (superSelectTableProps) {
                        const newInitOptions = getInitOptions({
                          initValues: initValues?.content,
                          labelKey,
                          valueKey,
                          initOptions: superSelectTableProps?.initOptions,
                          labelField: superSelectTableProps?.labelKey || DEFAULT_FIELD_NAMES.label,
                          valueField: superSelectTableProps?.valueKey || DEFAULT_FIELD_NAMES.value,
                        });
                        childrenFormItems.push({
                          ...restItem,
                          required: true,
                          superSelectTableProps: {
                            ...superSelectTableProps,
                            initOptions: newInitOptions,
                          },
                        });
                      }
                      break;
                    case 'SelectGroupTable':
                      const { namekey, valuekey, disabledRenderKey, afterSelectTableProps, } = item;
                      if (afterSelectTableProps) {
                        const newInitOptions = getInitOptions({
                          initValues: initValues?.content,
                          labelKey: namekey,
                          valueKey: valuekey,
                          initOptions: afterSelectTableProps?.initOptions,
                          labelField: afterSelectTableProps?.nameKey || DEFAULT_FIELD_NAMES.label,
                          valueField: afterSelectTableProps?.valueKey || DEFAULT_FIELD_NAMES.value,
                        });
                        if (disabledRenderKey && initValues?.content) {
                          if (typeof disabledRenderKey === 'function') {
                            item.disabledRender = disabledRenderKey(initValues.content);
                          }
                          if (typeof disabledRenderKey === 'string') {
                            item.disabledRender = initValues.content[disabledRenderKey];
                          }
                        }
                        childrenFormItems.push({
                          ...restItem,
                          required: true,
                          afterSelectTableProps: {
                            ...afterSelectTableProps,
                            initOptions: newInitOptions,
                          },
                        });
                      }
                      break;
                    default:
                      if (item.disabledRenderKey) {
                        item.disabledRender = typeof item.disabledRenderKey === 'function' ? item.disabledRenderKey(optionalValues) : initValues?.content?.[item.disabledRenderKey];
                      }
                      childrenFormItems.push({ ...restItem, required: true, });
                  }
                }
              });
              if (childrenFormItems.length) {
                newContentFormItems.push({
                  label: findGroup.label,
                  name: findGroup.value,
                  formItemType: 'Group',
                  children: childrenFormItems,
                });
              }
            }
          }
        }
        if (initValues?.rule) {
          newRuleFormItems = setOptionsFormItems(state.ruleFormItems, initValues.rule);
        }
        if (initValues?.action) {
          newActionFormItems = setOptionsFormItems(state.actionFormItems, initValues.action);
        }
        return {
          ...state,
          ruleFormItems: newRuleFormItems,
          contentFormItems: newContentFormItems,
          actionFormItems: newActionFormItems,
        };
      }
      return state;
    case 'changeFormItem':
      const { groupOptions } = action.payload;
      if (!groupOptions) return state;
      const optionalFormItems = state.optionalFormItems;
      const findGropp = optionalFormItems.find(item => item.value === groupOptions.name);
      if (findGropp) {
        const groupChildren = findGropp.children.filter(item => {
          return item.name && groupOptions.value.includes(item.name as string);
        }).map(item => {
          const { disabled, ...restItem } = item;
          return { ...restItem, required: true, };
        });
        const oldContentFormItems = state.contentFormItems;
        let newContentFormItems: SuperFormItemProps[] = [];
        // contentFormItems为空
        if (!oldContentFormItems || !oldContentFormItems.length) {
          if (!groupChildren.length) return state;
          newContentFormItems.push({
            label: findGropp.label,
            name: groupOptions.name,
            formItemType: 'Group',
            children: groupChildren,
          });
          return {
            ...state,
            contentFormItems: newContentFormItems,
          };
        }
        const findItem = state.contentFormItems.find(item => item.name === groupOptions.name);
        // contentFormItems有值且存在当前分组
        if (findItem) {
          oldContentFormItems.forEach(item => {
            if (item.name === groupOptions.name) {
              if (!groupChildren.length) return;
              newContentFormItems.push({
                ...item,
                children: groupChildren,
              });
              return;
            }
            newContentFormItems.push(item);
          });
          return {
            ...state,
            contentFormItems: newContentFormItems,
          };
        }
        // contentFormItems有值且不存在当前分组
        newContentFormItems = oldContentFormItems;
        if (groupChildren.length) {
          newContentFormItems.push({
            label: findGropp.label,
            name: groupOptions.name,
            formItemType: 'Group',
            children: groupChildren,
          });
        }
        return {
          ...state,
          contentFormItems: newContentFormItems,
        };
      }
      return state;
    case 'empty':
      const oldContentFormItems = state.contentFormItems;
      const newContentFormItems: SuperFormItemProps[] = [];
      oldContentFormItems.forEach(group => {
        const { children, ...restGroup } = group;
        if (Array.isArray(children) && children.length) {
          const filterChildren = children.filter(item => !!item.defaultChecked);
          if (filterChildren.length) {
            newContentFormItems.push({
              ...restGroup,
              children: filterChildren,
            });
          }
        }
      });
      return {
        ...state,
        contentFormItems: newContentFormItems,
      };
    default:
      return state;
  }
}

function useStrategyPagehook(
  optionalFormRef: MutableRefObject<FormInstance<any> | undefined>,
  ruleFormItems?: SuperFormItemProps[],
  optionalFormItems?: IOptionalFormItems[],
  actionFormItems?: SuperFormItemProps[],
) {
  const [strategyPageData, dispatch] = useReducer(strategyPageAction, initStrategyPageData);
  useEffect(() => {
    dispatch({ type: 'init', payload: {ruleFormItems, optionalFormItems, actionFormItems, optionalFormRef,}});
  }, [ruleFormItems, optionalFormItems, actionFormItems]);
  function dispatchStrategyPage(
    type: StrategyPageType,
    payload: IStrategyPagePayload,
  ) {
    return dispatch({type, payload});
  }
  return {
    ...strategyPageData,
    dispatch: dispatchStrategyPage,
  };
}

export default useStrategyPagehook;
